import React, { useEffect, useRef, useState } from 'react';
import { Loader } from 'js/components/common/Loader';
import animate, { getRandomGames, getCurrentWheelFace } from './helpers';
import animCss from '../animation.scss';
import style from './index.scss';

export const FACES_TILT_ANGLE = 18;
export const FACES_LENGTH = 20;

export const rotateWheel = ({ setState }) => (progress) => {
    // progress - is float number in range between 0 and 1
    const wheelRotationAngle = -Math.round(progress * 200) * FACES_TILT_ANGLE;
    const wheel = document.querySelector(`.${style.wheel}`);

    if (wheel) {
        wheel.style.transform = `rotateX(${wheelRotationAngle}deg)`;
    }
    setState('wheelRotationAngle', wheelRotationAngle);
};

export const useAnimationState = () => {
    const ref = useRef({});
    const setState = (name, value) => ref.current[name] = value;
    const getState = name => name ? ref.current[name] : ref.current;

    return {
        setState,
        getState
    };
};

export default ({ currentGameItem, setCurrentGameItem, classNames = {}, browserName, games }) => {
    const [randomGames] = useState(getRandomGames(games, FACES_LENGTH));
    const { setState, getState } = useAnimationState();
    const showLoader = browserName === 'ie';

    useEffect(() => {
        animate({
            draw: rotateWheel({ setState, getState }),
            onProgress: id => setState('frameId', id),
            onAnimationEnd: () => {
                const { wheelRotationAngle } = getState();
                const wheelFace = getCurrentWheelFace({
                    wheelRotationAngle,
                    faceTiltAngle: FACES_TILT_ANGLE,
                    facesLength: FACES_LENGTH
                });

                setCurrentGameItem(randomGames[wheelFace]);
            }
        });

        return () => cancelAnimationFrame(getState('frameId'));

    }, []);

    let rotateX = 0;

    return (
        <>
            {showLoader
                ? <Loader />
                : <div className={style.scene}>
                    <div className={style.wheel}>
                        {randomGames.map((game, idx) => {
                            const inlineCss = {
                                transform: `rotateX(${rotateX}deg) translateZ(7em)`
                            };
                            const el = <div key={idx} style={inlineCss} className={style.wheelFace}>
                                <div className={style.text}>{game.name}</div>
                            </div>;

                            rotateX += FACES_TILT_ANGLE;

                            return el;
                        })}
                    </div>
                </div>
            }
            {currentGameItem != null && (
                <div className={`${style.active} ${classNames.active} ${animCss.fadeIn}`}>
                    <div className={`${style.text} ${animCss.zoomIn}`}>
                        {currentGameItem.name}
                    </div>
                </div>
            )}
        </>
    );
};
